<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Very Dissatisfied" class="d-icon d-icon--very-dissatisfied" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><g :clip-path="`url(#${uniqueID}a)`"><path fill="currentColor" fill-rule="evenodd" d="M5.899 1.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9ZM.399 6a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0Zm2.435-1.777a.5.5 0 0 1 .693-.14l.197.132a.5.5 0 0 0 .555-.001l.193-.13a.5.5 0 1 1 .556.832l-.193.129a1.5 1.5 0 0 1-1.664.003l-.198-.132a.5.5 0 0 1-.14-.693Zm4 0a.5.5 0 0 1 .693-.14l.197.132a.5.5 0 0 0 .555-.001l.193-.13a.5.5 0 1 1 .556.832l-.193.129a1.5 1.5 0 0 1-1.664.003l-.198-.132a.5.5 0 0 1-.14-.693ZM5.899 6a2.641 2.641 0 0 0-1.608.517c-.46.345-.78.836-.883 1.39a.5.5 0 0 0 .49.593h4a.5.5 0 0 0 .492-.592 2.268 2.268 0 0 0-.883-1.39A2.641 2.641 0 0 0 5.9 6Zm-.006 1a1.642 1.642 0 0 0-1.002.317 1.41 1.41 0 0 0-.201.183h2.418a1.409 1.409 0 0 0-.2-.183A1.642 1.642 0 0 0 5.904 7h-.012Z" clip-rule="evenodd"/></g><defs><clipPath :id="`${uniqueID}a`"><path fill="#fff" d="M0 0h12v12H0z"/></clipPath></defs></svg>
</template>

<script>
import { getUniqueString } from '@/src/utils';
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconVeryDissatisfied',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
    this.uniqueID = getUniqueString();
  },
};
</script>
